import { render, staticRenderFns } from "./RemainingVue.vue?vue&type=template&id=6440e862&scoped=true"
import script from "./RemainingVue.vue?vue&type=script&lang=js"
export * from "./RemainingVue.vue?vue&type=script&lang=js"
import style0 from "./RemainingVue.vue?vue&type=style&index=0&id=6440e862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6440e862",
  null
  
)

export default component.exports